import React, { memo } from 'react'
import { Stack } from '@mui/material'
import { NavLink } from 'react-router-dom'

import Text from '../text/Text'
import ProviderIcon from '../exchangeProviderCard/ProviderIcon'
import { MEMBERSHIP_URL } from '../../../constants/navigation'

const MembershipBadge = ({
  t,
  userTier: {
    tier: { id, name }
  }
}) => {
  return (
    <NavLink to={MEMBERSHIP_URL} style={{ textDecoration: 'none' }}>
      <Stack
        spacing={1}
        direction='row'
        alignItems='center'
        sx={{
          display: { xs: 'none', sm: 'flex' },
          color: 'var(--layout-nav-text-primary-color)',
          bgcolor: 'background.neutral',
          borderRadius: 2,
          px: 2,
          py: 1,
          gap: 1,
          ml: 2
        }}
      >
        <ProviderIcon size={26} src={`/assets/tiers/${id}-s.png`} />
        <Text variant='subtitle2' label={`${t('common.status')}: ${name}`} />
      </Stack>
    </NavLink>
  )
}

export default memo(MembershipBadge)
